import { NotFoundScreen } from '../components/not-found-screen';
import { RouteErrorFallback } from '../components/route-error-fallback';

/** 라우트별 기본 오류·not-found 화면. 각 라우트의 `Outlet` 자리에서 렌더돼 앱 헤더가 남는다. */
export const routerFallbacks = {
  defaultErrorComponent: RouteErrorFallback,
  defaultNotFoundComponent: NotFoundScreen,
} as const;
